// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7) return "css/main.css";
	// return url for filenames based on template
	return "css/cid_" + chunkId + ".css";
};